import { getViaWebWorker, post } from './API'

export const getProfile = (params) => {
  const uri = `/me`
  return getViaWebWorker(uri, params, {
    baseURL: 'https://graph.facebook.com'
  })
}

export const getAccounts = (params) => {
  const uri = `/${params.facebook_id}/accounts`
  return getViaWebWorker(uri, params, {
    baseURL: 'https://graph.facebook.com'
  })
}

export const getIdsForBusiness = (params) => {
  const uri = `/${params.facebook_id}/ids_for_apps`
  return getViaWebWorker(uri, params, {
    baseURL: 'https://graph.facebook.com'
  })
}

export const getConversations = (params) => {
  // params: page_id, access_token (page)
  const uri = `/${params.page_id}/conversations`
  return getViaWebWorker(uri, params, {
    baseURL: 'https://graph.facebook.com'
  })
}

export const getMessages = (params) => {
  // params: conversation_id, access_token (page)
  const uri = `/${params.conversation_id}/messages`
  return getViaWebWorker(uri, params, {
    baseURL: 'https://graph.facebook.com'
  })
}

export const getBatchMessages = (params) => {
  // params: batch, access_token (page)
  const uri = `/me?batch=${JSON.stringify(params.batch)}&include_headers=false&access_token=${
    params.access_token
  }`
  return post(
    uri,
    {},
    {
      baseURL: 'https://graph.facebook.com'
    }
  )
}

export const getAddressByMobile = (params) => {
  const uri = '/insight/customer'
  return getViaWebWorker(uri, params, {
    baseURL: global.$_VUE_APP_REST_API
  })
}

export const getOrderSuggestionList = (params) => {
  const uri = '/order/suggestions'
  return getViaWebWorker(uri, params, {
    baseURL: global.$_VUE_APP_REST_API,
    token_required: true
  })
}
